module.exports = __webpack_public_path__ + "static/media/Barmag 5b1.ef2d778e.jpg";